
import { fork, } from 'redux-saga/effects';

// Sagas
import {
  family_members,
} from './membership'

import { fetch_booking, fetch_bookings, fetch_bookings_more, assign_piece_to_book,
  free_up_pieces_from_book, fetch_day, fetch_range,
  fetch_booking_logs, free_up_piece_from_book, fetch_arriving_today } from './bookings';
import { fetch_properties, fetch_property, fetch_property_logs } from './properties';
import { fetch_countries, fetch_countries_all, fetch_nationalities } from './countries';
import { fetch_room, fetch_rooms, archive_room, toggle_room } from './rooms';
import { fetch_periods, fetch_period, toggle_period, archive_period } from './periods';
import { fetch_offers, toggle_offer, archive_offer, fetch_offer } from './offers';
import { fetch_plans, fetch_plan, toggle_plan, archive_plan } from './plans';
import { fetch_staff, fetch_staffs, toggle_staff, archive_staff } from './staffs';
import { fetch_floors, update_piece_status, update_block_reason, assign_piece_staff, 
  unassign_piece_staff, fetch_piece_comments, add_piece_comments } from './floors';
import { fetch_accounting, fetch_payment_methods, fetch_close_report, fetch_charges_report, fetch_transfer_targets } from './accounting';
import { fetch_logic_occupancy, fetch_logic_occupancy_graph, fetch_conversion_rates } from './logic';
import { fetch_guests, fetch_guest, fetch_guest_bookings, search_guests } from './guests';
import { fetch_coorps, fetch_coorp, fetch_all_coorps, search_coorps } from './coorps';
import { fetch_hk_items, create_hk_item, update_hk_item, delete_hk_item, fetch_hk_movements, register_hk_movement } from './housekeeping';
import { fetch_charge_types, create_charge_type, update_charge_type, delete_charge_type,
  fetch_rate_types, create_rate_type, update_rate_type, delete_rate_type } from './settings';

export default function* rootSaga() {
  yield [
    // Membership
    fork(family_members),

    // Properties
    fork(fetch_properties),
    fork(fetch_property),
    fork(fetch_property_logs),

    // Rooms
    fork(fetch_rooms),
    fork(fetch_room),
    fork(archive_room),
    fork(toggle_room),

    // Periods
    fork(fetch_periods),
    fork(fetch_period),
    fork(toggle_period),
    fork(archive_period),

    // Offers
    fork(fetch_offers),
    fork(toggle_offer),
    fork(archive_offer),
    fork(fetch_offer),

    // Plans
    fork(fetch_plans),
    fork(fetch_plan),
    fork(toggle_plan),
    fork(archive_plan),
    
    // Staffs
    fork(fetch_staffs),
    fork(fetch_staff),
    fork(toggle_staff),
    fork(archive_staff),

    // Countries
    fork(fetch_countries),
    fork(fetch_countries_all),
    fork(fetch_nationalities),

    // Bookings
    fork(fetch_booking),
    fork(fetch_bookings),
    fork(fetch_bookings_more),
    fork(assign_piece_to_book),
    fork(free_up_piece_from_book),
    fork(free_up_pieces_from_book),
    fork(fetch_day),
    fork(fetch_range),
    fork(fetch_booking_logs),
    fork(fetch_close_report),
    fork(fetch_arriving_today),

    // Floors
    fork(fetch_floors),
    fork(update_piece_status),
    fork(update_block_reason),
    fork(assign_piece_staff),
    fork(unassign_piece_staff),
    fork(fetch_piece_comments),
    fork(add_piece_comments),

    // Accounting
    fork(fetch_accounting),
    fork(fetch_payment_methods),
    fork(fetch_charges_report),
    fork(fetch_transfer_targets),

    // Logic
    fork(fetch_logic_occupancy),
    fork(fetch_logic_occupancy_graph),
    fork(fetch_conversion_rates),

    // Guests
    fork(fetch_guests),
    fork(fetch_guest),
    fork(fetch_guest_bookings),
    fork(search_guests),

    // Coorps
    fork(fetch_coorps),
    fork(fetch_coorp),
    fork(fetch_all_coorps),
    fork(search_coorps),

    // Housekeeping inventory
    fork(fetch_hk_items),
    fork(create_hk_item),
    fork(update_hk_item),
    fork(delete_hk_item),
    fork(fetch_hk_movements),
    fork(register_hk_movement),

    // Settings
    fork(fetch_charge_types),
    fork(create_charge_type),
    fork(update_charge_type),
    fork(delete_charge_type),
    fork(fetch_rate_types),
    fork(create_rate_type),
    fork(update_rate_type),
    fork(delete_rate_type),
  ]
}